import * as React from 'react';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkCardMedia } from 'uitk-react-cards';
import { PwaHsrPropertyDestinationRefinement } from '__generated__/api';

export interface DestinationRefinementImageProps {
  image: PwaHsrPropertyDestinationRefinement.Image;
}

export const DestinationRefinementImage: React.FunctionComponent<DestinationRefinementImageProps> = ({ image }) => (
  <UitkCardMedia>
    <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
      <UitkImage alt={image.description ? image.description : ''} src={image.url} placeholderImage={true} />
    </UitkFigure>
  </UitkCardMedia>
);
